export default __webpack_public_path__ + "static/media/nutrition-app.706f081a.png";